module.exports = __webpack_public_path__ + "img/car_shina2_32.007d7d00.jpg";